<script setup lang="ts"></script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="24" height="24" fill="url(#pattern0_5017_2)" />
    <defs>
      <pattern
        id="pattern0_5017_2"
        patternUnits="userSpaceOnUse"
        patternTransform="matrix(7 0 0 7 0 0)"
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
        width="1"
        height="1"
      >
        <g id="pattern0_5017_2_inner">
          <rect y="10" width="10" height="10" fill="#FF0000" />
          <rect x="10" width="10" height="10" fill="#FF0000" />
        </g>
      </pattern>
    </defs>
  </svg>
</template>
